import styled from 'styled-components'
import { getFontStyle, makeLineClamp } from '@diversioteam/diversio-ds'

import { PulseSurveyLinkStyleProps } from './pulseSurveyLink.types'

export const PulseSurveyLinkWrapper = styled.div<PulseSurveyLinkStyleProps>`
    grid-area: survey-link;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    background-color: ${({ theme, size }) => {
        if (size === 'small') {
            return theme.colors.primaryWhite
        }

        return theme.colors.primary10
    }};
    border: ${({ theme, size }) => {
        if (size === 'small') {
            return `1px solid ${theme.colors.primaryGray2}`
        }

        return `1px solid ${theme.colors.primary35}`
    }};
    border-radius: 15px;
`

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
`

export const Description = styled.span`
    color: ${({ theme }) => theme.colors.primary90};

    ${getFontStyle('p03Regular')}
`

export const LinkContainer = styled.div<PulseSurveyLinkStyleProps>`
    padding: ${({ size }) => (size === 'small' ? '10px 10px 10px 20px' : '16px 10px 16px 20px')};
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.colors.secondary100Transparent};
    background-color: ${({ theme }) => theme.colors.primaryWhite};
`

export const LinkInput = styled.input`
    flex: 1;
    border: none;
    background-color: transparent;
    color: ${({ theme }) => theme.colors.primary90};

    ${makeLineClamp(1)}

    ${getFontStyle('p01Regular')}
`
